import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import Button from '@mui/material/Button';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import Header from './components/Header';
import Footer from 'examples/Footer';
import { apiGetNotice } from '../../../api/notice.api';
import { Buffer } from 'buffer'; // Buffer 라이브러리 임포트
import ReactHtmlParser from 'react-html-parser';
import { Divider } from '@mui/material';
import { useData } from '../../../hooks';

const NoticeDetail = () => {
  const { id } = useParams(); // URL 파라미터에서 id를 가져옴
  const navigate = useNavigate();
  const location = useLocation();
  const [notice, setNotice] = useState(null);
  const [loading, setLoading] = useState(true);
  const { user, appIsReady } = useData();

  useEffect(() => {
    if (id && appIsReady && user) {
      fetchNotice(id);
    }
  }, [id, user, appIsReady]);

  const fetchNotice = async (noticeid) => {
    setLoading(true);
    try {
      const response = await apiGetNotice(noticeid, user.accessToken);
      if (response && response.content && response.content.data) {
        const decodedContent = Buffer.from(response.content.data).toString(
          'utf8',
        );
        setNotice({ ...response, content: decodedContent });
      } else {
        setNotice(response);
      }
    } catch (error) {
      console.error('Error fetching notice:', error);
    } finally {
      setLoading(false);
    }
  };

  const messageTypeToString = (type) => {
    switch (type) {
      case 1:
        return '앱공지';
      case 3:
        return '매뉴얼';
      case 4:
        return '점주용공지';
      case 5:
        return '점주용매뉴얼';
      default:
        return '기타';
    }
  };

  const handleBack = () => {
    // URLSearchParams를 사용하여 상태를 포함시킵니다.
    const searchParams = new URLSearchParams();
    searchParams.set('messageType', location.state.messageType);
    navigate(`/boards?${searchParams.toString()}`);
  };

  if (loading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <Header />
        <MDBox pt={6} pb={3}>
          <MDTypography variant='h4' color='info'>
            Loading...
          </MDTypography>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Header>
        <MDBox pt={6} pb={3}>
          {notice ? (
            <>
              <MDBox mb={2} display='flex' justifyContent='space-between'>
                <MDTypography variant='h4' fontWeight='bold'>
                  {messageTypeToString(notice.title)}
                </MDTypography>
                <MDTypography variant='body2'>
                  작성일: {new Date(notice.createdAt).toLocaleDateString()}
                </MDTypography>
              </MDBox>

              <MDBox mt={3} width='100%'>
                <MDTypography variant='body1'>
                  {ReactHtmlParser(notice.content)}
                </MDTypography>
              </MDBox>
              <MDBox mt={2}>
                <Button
                  variant='contained'
                  color='success'
                  onClick={handleBack}
                >
                  뒤로 가기
                </Button>
              </MDBox>
            </>
          ) : (
            <MDTypography variant='h4' color='info'>
              Notice not found
            </MDTypography>
          )}
        </MDBox>
      </Header>
      <Footer />
    </DashboardLayout>
  );
};

export default NoticeDetail;
